export const environment = {
    production: false,
    serverUrl: 'https://qrvkre2xfe.execute-api.us-east-2.amazonaws.com/dev',
    bucket: 'redthreadaudit-demo-upload',
    userPool: {
      UserPoolId: 'us-east-2_p5hbm0xBK',
      ClientId: '1fi2lh0dlbn20egmvbinv6che5',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:9fb6c7d7-513a-4cca-bff5-1537145086d3',
    buckets: {
      'us-east-2': 'redthreadaudit-demo-upload'
    },
    modules: {
      key: 'analysisType',
      values: [
             {
            'name': 'LMR',
            'desc': 'Large Molecule Report'
        },
        
      ]
  },
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId: 'us-east-2:9fb6c7d7-513a-4cca-bff5-1537145086d3', // REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_p5hbm0xBK', // OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '1fi2lh0dlbn20egmvbinv6che5', // OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'redthreadaudit-demo-upload', // REQUIRED -  Amazon S3 bucket
        region: 'us-east-2', // OPTIONAL -  Amazon service region
      }
    }
  };
  const awsconfig = {
    'aws_project_region': 'us-east-2',
    'aws_cognito_region': 'us-east-2',
    'aws_user_pools_id': 'us-east-2_p5hbm0xBK',
    'aws_user_pools_web_client_id': '1fi2lh0dlbn20egmvbinv6che5',
    'aws_cognito_mfa_configuration': 'OPTIONAL',
  
  };
  export default awsconfig;
  
  